class ColorPaletteManager {
  constructor() {
    this.data = [];
  }

  load(onComplete) {
    return;
    fetch('/street-gallery/assets/colors.json?cache=1234')
      .then((response) => response.json())
      .then((json) => {
        this.data = json;
        if (onComplete) onComplete();
      });
  }

  getItemById(id) {
    const item = this.data.find((x) => x.assetId === id);

    if (item && item.palette) return item;
    return null;
  }
}
export default ColorPaletteManager;
